<script setup lang="ts">

</script>

<template>
    <StfRow gap="0">
        <StfCol col="6" class="pt-1 pr-4 pb-2">
            <slot name="left"/>
        </StfCol>
        <StfCol col="6" class="stf-border stf-border--left stf-border--fat pb-2 px-4" style="background-color: #f2f2f2;">
            <slot name="right"/>
        </StfCol>
    </StfRow>
</template>
